import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const deleteResource = async ({ resourceId, projectId }) => {
  const response = await axios.delete(
    `${API_URL}/v1/project/${projectId}/provider/hosting/resource/${resourceId}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useDeleteResource = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();

  return useMutation(deleteResource, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['resources']);
      notify({ message: 'Resource was deleted successfully', severity: 'success' });
    }
  });
};
